/* istanbul ignore file - better tested visually */
import { Button as MuiButton } from '@mui/material';
import { classNames } from '@partful/shared/lib/classNames';
import { useGoogleAnalytics } from '@partful/shared/lib/hooks/useGoogleAnalytics';
import React, { ComponentProps, ElementType, forwardRef } from 'react';
import styles from './Button.module.scss';

export type ButtonProps = {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'destructive';
  size?: 'small' | 'medium' | 'large';
  icon?: boolean;
  linkComponent?: ElementType<any, keyof JSX.IntrinsicElements>;
  to?: string;
  rounded?: boolean;
} & Pick<ComponentProps<'a'>, 'download' | 'href' | 'hrefLang' | 'referrerPolicy' | 'rel' | 'target'>;

export const Button = forwardRef<HTMLButtonElement, Omit<ComponentProps<'button'>, 'color'> & ButtonProps>(
  (
    { variant = 'primary', size = 'medium', icon, rounded, linkComponent, name, className, onClick, children, ...rest },
    ref
  ) => {
    const { sendEvent } = useGoogleAnalytics();

    const onClickWithAnalytics = (mouseEvent: React.MouseEvent<HTMLButtonElement>): void => {
      onClick?.(mouseEvent);

      if (name) {
        sendEvent(name);
      }
    };

    return (
      <MuiButton
        variant="contained"
        size={size}
        className={classNames(
          styles.base,
          styles[size],
          styles[variant],
          icon ? styles.icon : undefined,
          rounded ? styles.rounded : undefined,
          className
        )}
        LinkComponent={linkComponent}
        name={name}
        onClick={onClickWithAnalytics}
        {...rest}
        ref={ref}
      >
        {children}
      </MuiButton>
    );
  }
);
